/**
 * How close to the bottom (in px) the chat must be scrolled to count as "at
 * the bottom", so a message arriving while you read the latest ones scrolls
 * into view, but not while you are reading older history.
 */
export const FOLLOW_NEW_MESSAGES_THRESHOLD_PX = 80;

/** Whether a scroll container is within the threshold of its bottom. */
export function isNearBottom(
  el: Pick<HTMLElement, 'scrollTop' | 'scrollHeight' | 'clientHeight'>
): boolean {
  return el.scrollHeight - el.scrollTop - el.clientHeight <= FOLLOW_NEW_MESSAGES_THRESHOLD_PX;
}

/**
 * Whether to scroll to a newly arrived message: only when the newest message
 * changed (a message was appended, not older ones prepended) and the reader
 * was at the bottom before it arrived.
 */
export function shouldFollowNewMessage({
  previousNewestId,
  newestId,
  wasNearBottom,
}: {
  previousNewestId: string | null;
  newestId: string | null;
  wasNearBottom: boolean;
}): boolean {
  return (
    previousNewestId !== null && newestId !== null && newestId !== previousNewestId && wasNearBottom
  );
}
